import React from "react";
import { motion } from "framer-motion";
import { Clock, ShieldAlert, Sparkles, HeartHandshake, BadgeCheck, Workflow } from "lucide-react";

const benefits = [
  { icon: Clock, title: "Ahorra tiempo", text: "Nosotros nos encargamos del proceso completo mientras tú sigues con tu vida." },
  { icon: ShieldAlert, title: "Evita compras arriesgadas", text: "Inspección técnica profesional antes de cualquier transferencia." },
  { icon: Sparkles, title: "Accede a mejores opciones", text: "Modelos y versiones que en España son imposibles de encontrar." },
  { icon: HeartHandshake, title: "Acompañamiento profesional", text: "Un equipo experto contigo en cada decisión importante." },
  { icon: BadgeCheck, title: "Importa con confianza", text: "Procedimiento legal y fiscal correcto, sin riesgos administrativos." },
  { icon: Workflow, title: "Proceso claro de principio a fin", text: "Sin letra pequeña, sin sorpresas. Todo documentado." },
];

export const Benefits = () => {
  return (
    <section
      id="beneficios"
      className="relative py-24 sm:py-32 bg-[#0A0A0A] border-t border-white/5"
      data-testid="benefits-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mb-16"
        >
          <span className="text-xs uppercase tracking-[0.32em] text-[#D4AF37]">Beneficios</span>
          <h2 className="font-heading mt-6 text-3xl sm:text-5xl font-light tracking-tight text-[#FFFFF0] leading-tight">
            Lo que ganas al importar con Elecars.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5">
          {benefits.map((b, i) => (
            <motion.div
              key={b.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              className="group bg-[#0A0A0A] p-8 sm:p-10 hover:bg-[#141414] transition-all duration-500 relative overflow-hidden card-lift"
              data-testid={`benefit-card-${i}`}
            >
              <div className="absolute top-0 right-0 w-px h-0 bg-[#D4AF37] group-hover:h-full transition-all duration-700" />
              <b.icon className="w-7 h-7 text-[#D4AF37] mb-6" strokeWidth={1.2} />
              <h3 className="font-heading text-lg sm:text-xl font-medium text-[#FFFFF0] mb-3 leading-snug">{b.title}</h3>
              <p className="text-sm text-[#A3A3A3] leading-relaxed font-light">{b.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
